<template>
  <NuxtPwaManifest />

  <NuxtPage />
  <LoadingBar v-if="loader.isLoading" />
  <DialogRouter v-if="!isPdfViewer" />
</template>
<script lang="ts" setup>
const route = useRoute();
const isPdfViewer = computed(() => route.path === '/pdf/viewer');
const loader = useAppLoadingStore();
useI18nForEva();
useKameleoon();
</script>
<style lang="scss" scoped></style>
